// Portais que já têm URL própria, mas ainda não têm direito de acesso próprio
// no CIGAM: login, sessão e perfil usam o direito do portal indicado. Ao criar
// os direitos do portal, remover a entrada daqui.
const PORTAL_DE_ACESSO: Record<string, string> = {
  // Planejamento Integrado de Demandas (MPS): direito do Portal Indústria.
  portalmps: 'portalindustria',
};

// Portal enviado à API (login, sessão e perfil) para o portal da URL.
export const portalDeAcesso = (portal = '') =>
  PORTAL_DE_ACESSO[portal] ?? portal;

export default portalDeAcesso;
